var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditOption = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23019_12958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.33333C10.9206 3.33333 11.6668 2.58714 11.6668 1.66667C11.6668 0.746192 10.9206 0 10.0002 0C9.07969 0 8.3335 0.746192 8.3335 1.66667C8.3335 2.58714 9.07969 3.33333 10.0002 3.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 11.6673C10.9206 11.6673 11.6668 10.9211 11.6668 10.0006C11.6668 9.08018 10.9206 8.33398 10.0002 8.33398C9.07969 8.33398 8.3335 9.08018 8.3335 10.0006C8.3335 10.9211 9.07969 11.6673 10.0002 11.6673Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 19.9994C10.9206 19.9994 11.6668 19.2532 11.6668 18.3327C11.6668 17.4122 10.9206 16.666 10.0002 16.666C9.07969 16.666 8.3335 17.4122 8.3335 18.3327C8.3335 19.2532 9.07969 19.9994 10.0002 19.9994Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23019_12958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditOption, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-option.a5b3f701.svg";
export { ForwardRef as ReactComponent };